import { render, staticRenderFns } from "./businessInformationPage.vue?vue&type=template&id=38b94326&scoped=true&"
import script from "./businessInformationPage.vue?vue&type=script&lang=ts&"
export * from "./businessInformationPage.vue?vue&type=script&lang=ts&"
import style0 from "./businessInformationPage.vue?vue&type=style&index=0&id=38b94326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b94326",
  null
  
)

export default component.exports